<template>
  <div class="memberIndex">
    <div class="right">
      <div class="currentMenu">招标答疑</div>
      <div class="right_content">
        <div class="change_inform">
          <div class="title">招标答疑</div>
        </div>
        <div class="right_out">
          <div style="padding: 5px; margin: 10px">
            <span>项目名称</span>
            <el-input type="text" class="input" v-model="Query.ProjectName" size="mini"></el-input>
            <span>招标方式</span>
            <el-select class="input" v-model="Query.PurchaseMethod" placeholder="请选择">
              <el-option v-for="item in PurchaseMethods" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
            </el-select>
            <span>项目类型</span>
            <el-select class="input" v-model="Query.ProjectType" placeholder="请选择">
              <el-option v-for="item in ProjectTypes" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
            </el-select>
            <el-button id="search" @click="fnGetData">搜索</el-button>
          </div>
          <el-table class="table_wrap1" :data="schemeList" style="width: 100%">
            <el-table-column type="expand" style="padding: 0">
              <template slot-scope="props">
                <table class="statistics_table">
                  <tr>
                    <th class="th1">包组信息</th>
                    <th class="th1" style="width: 240px">操作</th>
                  </tr>
                  <tr v-for="(item, index) in props.row.schemeList" :key="index">
                    <td class="td1">{{ item.ProjectName }}-{{ item.GroupName }}</td>
                    <td class="td1">
                      <div class="btn_wrap">
                        <el-button class="btn" @click="fnAddQuestion(item.SchemeId, item.AutoId)" type="text" size="small" style="padding: 2px 5px">新增问题</el-button>
                        <el-button class="btn" @click="fnShowQuestions(item.SchemeId, item.AutoId)" type="text" size="small" style="padding: 2px 5px">查看问题</el-button>
                      </div>
                    </td>
                  </tr>
                </table>
              </template>
            </el-table-column>
            <el-table-column prop="SchemeCode" label="采购编号"></el-table-column>
            <el-table-column prop="ProjectName" label="项目名称">
              <template slot-scope="scope">
                <el-link @click="Detail(scope.row.SchemeId)" :underline="false" style="color: #0361b1; padding-right: 10px">{{ scope.row.ProjectName }}</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="PurchaseMethod" label="采购方式"></el-table-column>
            <el-table-column prop="ProjectType" label="项目类型"></el-table-column>
            <el-table-column prop="BidOpenningDate" label="开标时间"></el-table-column>
            <!-- <el-table-column label="操作" align="center">
							<template slot-scope="scope">
								<div class="btn_wrap">
									<el-button class="btn" @click="fnAddQuestion(scope.row.SchemeId, scope.row.AutoId)"
										type="text" size="small" style="padding: 2px 5px;">新增问题</el-button>
									<el-button class="btn"
										@click="fnShowQuestions(scope.row.SchemeId, scope.row.AutoId)" type="text"
										size="small" style="padding: 2px 5px;">查看问题</el-button>
								</div>
							</template>
						</el-table-column> -->
          </el-table>
        </div>
      </div>
    </div>
    <AddQuestion v-if="addQuestion" :scheme="scheme" :schemeId="schemeId" :autoId="autoId" :uploadUrl="uploadUrl" :addQuestion.sync="addQuestion"></AddQuestion>
    <QuestionDetail v-if="showQuestions" :scheme="scheme" :questions="questions" :showQuestions.sync="showQuestions"></QuestionDetail>
  </div>
</template>

<script>
import AddQuestion from './AddQuestion.vue'
import QuestionDetail from './QuestionDetail.vue'
export default {
  name: 'QuestionList',
  components: {
    AddQuestion,
    QuestionDetail
  },
  data() {
    return {
      Query: {
        ProjectName: '',
        PurchaseMethod: '',
        ProjectType: ''
      },
      height: {
        height: ''
      },
      activeIndex: '',
      Certify: true,
      loginInfos: {},
      schemeList: [],
      PurchaseMethods: [],
      ProjectTypes: [],
      addQuestion: false,
      showQuestions: false,
      scheme: {},
      questions: [], //采购方案的问题列表
      autoId: '',
      schemeId: '',
      uploadUrl: '',
      ownPurchaseMethod: [1, 2, 3, 4, 5, 6, 7] //查看所有招标方式
    }
  },
  created() {
    // this.heightCom();
  },
  computed: {},
  mounted() {
    this.AddListener()
    this.fnInit()
    this.fnGetData()
  },
  methods: {
    AddListener() {
      //监听（刷新列表）
      window.addEventListener('storage', (e) => {
        if (e.key == 'QuestionList') {
          this.getData()
        }
      })
    },
    fnGetData() {
      let config = {
        params: {
          Query: JSON.stringify(this.Query)
        }
      }
      this.getRequest('/QuestionManage/GetSchemeList', config)
        .then((res) => {
          if (res.data.errcode == 0) {
            this.uploadUrl = res.data.uploadUrl
            this.schemeList = res.data.schemeList
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    fnUpload(id) {
      let routerData = this.$router.resolve({
        name: 'InvitationReciept',
        query: {
          id: id
        }
      })
      window.open(routerData.href, '_blank')
    },
    heightCom() {
      this.height.height = window.innerHeight - 60 + 'px'
    },
    handleSelect(val) {
      console.log(val)
    },
    fnInit() {
      let config = {
        params: {
          PurchaseMethod: JSON.stringify(this.ownPurchaseMethod)
        }
      }
      //获取下拉列表
      this.getRequest('Purchase/GetInvitationQueryList', config)
        .then((res) => {
          if (res.data.errcode == 0) {
            this.PurchaseMethods = res.data.PurchaseMethods
            this.ProjectTypes = res.data.ProjectTypes
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    fnAddQuestion(schemeId, autoId) {
      let config = {
        params: {
          schemeId: schemeId
        }
      }
      this.getRequest('/QuestionManage/AddQuestion', config)
        .then((res) => {
          if (res.data.errcode == 0) {
            this.scheme = res.data.scheme
            this.autoId = autoId
            this.schemeId = schemeId
            this.addQuestion = true
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    fnShowQuestions(schemeId, autoId) {
      let config = {
        params: {
          schemeId: schemeId,
          autoId: autoId
        }
      }
      this.getRequest('/QuestionManage/GetQuestionList', config)
        .then((res) => {
          if (res.data.errcode == 0) {
            this.scheme = res.data.scheme
            this.questions = res.data.questionList
            this.showQuestions = true
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>
<style scoped lang="scss">
.memberIndex {
  display: flex;

  .left {
    width: 250px;
    min-width: 250px;
    background: #4f99d7;

    .logined_wrap {
      padding: 10px;

      .title span:nth-of-type(1) {
        font-weight: bold;
        color: #fff;
        margin-right: 5px;
      }

      .btn {
        border-top: 1px dashed #2db7f5;
        padding-top: 10px;
        margin-top: 10px;
      }

      .img {
        margin-left: 30px;
      }

      .list {
        li {
          font-size: 12px;
          padding: 5px 0;
          color: #d3e7f3;
          display: flex;
          align-items: center;

          .labell {
            font-weight: bold;
          }

          img {
            margin-right: 5px;
          }
        }
      }
    }
  }

  .right {
    background: #e4e4e4;
    flex: 1;
    padding: 0 0 10px 0;

    .right_out {
      width: 98%;
      margin: 0 auto;
    }

    .currentMenu {
      margin: 16px 5px;
    }

    .right_content {
      margin: 0 10px;
      height: 93%;
      background: #f7f7f7;
    }

    #search {
      width: 120px;
    }

    .input {
      width: 180px;
      margin-right: 50px;
      margin-left: 5px;
    }

    ::v-deep.el-input--mini .el-input__inner {
      height: 28px;
      line-height: 28px;
    }

    .btn_wrap {
      .btn {
        margin: auto;
        color: #6a96bc;
        border: 1px solid #6a96bc;
        border-radius: 5px;
        padding: 2px 18px;
      }
    }
  }
}

.statistics_table {
  width: 100%;
  // margin: 5px auto;

  th,
  td {
    text-align: center;
  }

  th {
    background-color: rgba(243, 251, 255, 1);
    color: #0179bd;
    font-weight: 700;
  }
}
</style>